import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide11bPromptenGutSchlecht(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Prompting — die Vertiefung</div>
        <h1 className="deck-title rise rise-2">
          Prompten heißt: <br />
          <span className="accent">präzise beauftragen</span>
        </h1>
        <p className="deck-sub rise rise-3">
          Beim Strategietag habt ihr die KI zum ersten Mal losgeschickt.
          Heute gehen wir tiefer — denn sie ist der beste Praktikant der
          Welt: kann fast alles, weiß nichts über euch.
        </p>
      </header>

      <div className="deck-cols2" style={{ gap: 20 }}>
        <div className="col-card rise rise-4" style={{ borderColor: "rgba(229, 72, 77, 0.5)" }}>
          <div className="col-eyebrow" style={{ color: "var(--svo-error, #e5484d)" }}>
            ✕ So nicht
          </div>
          <h4>„Mach mir was zu Reservierungen.“</h4>
          <p>
            Kein Ziel, keine Daten, keine Kriterien — die KI rät und liefert
            irgendwas. Nicht ihre Schuld: Der Auftrag war leer.
          </p>
        </div>
        <div className="col-card rise rise-5" style={{ borderColor: "rgba(0, 141, 247, 0.6)" }}>
          <div className="col-eyebrow">✓ So ja</div>
          <h4>
            „Baue eine Übersicht aller laufenden Leistungsreservierungen mit
            Anschlusspunkt, kW und Ablaufdatum. Markiere Kollisionen rot,
            sortiere nach Ablauf.“
          </h4>
          <p>
            Was, womit, wonach — jede Angabe ist prüfbar. Genau so entsteht
            in Minuten ein brauchbarer Prototyp.
          </p>
        </div>
      </div>

      <footer className="deck-foot">
        <span>
          Faustregel: Schreib den Prompt so, dass eine Fremdfirma ihn ohne
          Rückfrage umsetzen könnte.
        </span>
      </footer>
    </div>
  );
}
